import { StatistikEnv } from '../../env/StatistikEnv';
import { StatistikPageStore } from '../statistik/StatistikPageStore';
import { Store } from './Store';
import { TopicEnv } from '../../env/TopicEnv';

export class TopicStore {
  readonly store: Store;

  constructor(store) {
    this.store = store;
    if (typeof window !== 'undefined') {
      (window as any).topicStore = this;
    }
  }

  get topicData() {
    return this.store.storeData.topicData;
  }

  get pathNameSteps(): string[] {
    return this.topicData.topic.pathname.split('/');
  }

  get schooltypeName() {
    return this.pathNameSteps[1];
  }

  get formName() {
    return this.pathNameSteps[2];
  }

  get subjectName() {
    return this.pathNameSteps[3];
  }

  // @observable test = 1;
}
